module.exports = __webpack_public_path__ + "img/maintenance_vector.00e4b5fd.svg";